import { render, staticRenderFns } from "./FaqModal.vue?vue&type=template&id=0fbb1195&scoped=true"
import script from "./FaqModal.vue?vue&type=script&lang=js"
export * from "./FaqModal.vue?vue&type=script&lang=js"
import style0 from "./FaqModal.vue?vue&type=style&index=0&id=0fbb1195&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbb1195",
  null
  
)

export default component.exports